import { Button, useIsMobile } from '@brg/ui'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonTypography, ErrorInfo, ErrorText, ErrorTitle, PaymentErrorOuterWrapper, PaymentErrorWrapper } from './styles'
import { useDispatch } from 'react-redux'
import { SummaryInfoList } from '../OrderSummary/SummaryInfoList'
import { PaymentButtonSolid } from '../CheckOut/styles'
import { getCurrentContextName } from 'supporting'
import {goToStep} from "../../slices/OrderSlice";

interface PaymentErrorProps {
    onTryAgain?: () => void
    filled?: boolean
    hasSummaryInfo?: boolean
    text?: string
    secondTextLine?: string
}

export const PaymentError: FC<PaymentErrorProps> = ({ onTryAgain, hasSummaryInfo, filled = hasSummaryInfo, text, secondTextLine}) => {
    const { t } = useTranslation()
    const isMobile = useIsMobile()
    const contextName = getCurrentContextName();
    const isZeland = contextName === "zeland"
    const dispatch = useDispatch()

    const onTryAgainClick = () => {
        if(typeof(onTryAgain) === 'function') {
            onTryAgain()
        }
        dispatch(goToStep(1))
    }
    
  if (!isMobile) return (
    <PaymentErrorWrapper transparent={!filled}>
        <ErrorTitle>{t("send_gift.error.title")}</ErrorTitle>
        <ErrorText mb={secondTextLine ? 4 : undefined}>
            {t(text || '')}
        </ErrorText>
        { secondTextLine && <ErrorText>{t(secondTextLine)}</ErrorText>}
        {hasSummaryInfo &&
            <ErrorInfo>
                <SummaryInfoList offsetBottom={0} offsetTop={0}/>
            </ErrorInfo>
        }
        {
            isZeland
                ? <Button.YellowRectMedium onClick={onTryAgainClick}>
                    <ButtonTypography>{t("send_gift.error.try")}</ButtonTypography>
                </Button.YellowRectMedium>
                : <PaymentButtonSolid leveling onClick={onTryAgainClick}>{t("send_gift.error.try")}</PaymentButtonSolid>
        }
    </PaymentErrorWrapper>
  )

  return <PaymentErrorOuterWrapper>
        <ErrorTitle mobile={isMobile}>{t("send_gift.error.title")}</ErrorTitle>
        <ErrorText mobile={isMobile}>{text}</ErrorText>
        <PaymentErrorWrapper transparent={!filled} mobile={isMobile}>
            {hasSummaryInfo &&
                <SummaryInfoList offsetBottom={0} offsetTop={32}/>
            }
            <PaymentButtonSolid onClick={onTryAgainClick}>{t("send_gift.error.try")}</PaymentButtonSolid>
        </PaymentErrorWrapper>
    </PaymentErrorOuterWrapper>
}import { Button, useIsMobile } from '@brg/ui'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonTypography, ErrorInfo, ErrorText, ErrorTitle, PaymentErrorOuterWrapper, PaymentErrorWrapper } from './styles'
import { useDispatch } from 'react-redux'
import { SummaryInfoList } from '../OrderSummary/SummaryInfoList'
import { PaymentButtonSolid } from '../CheckOut/styles'
import { getCurrentContextName } from 'supporting'
import {goToStep} from "../../slices/OrderSlice";

interface PaymentErrorProps {
    onTryAgain?: () => void
    filled?: boolean
    hasSummaryInfo?: boolean
    text?: string
    secondTextLine?: string
}

export const PaymentError: FC<PaymentErrorProps> = ({ onTryAgain, hasSummaryInfo, filled = hasSummaryInfo, text, secondTextLine}) => {
    const { t } = useTranslation()
    const isMobile = useIsMobile()
    const contextName = getCurrentContextName();
    const isZeland = contextName === "zeland"
    const dispatch = useDispatch()

    const onTryAgainClick = () => {
        if(typeof(onTryAgain) === 'function') {
            onTryAgain()
        }
        dispatch(goToStep(1))
    }
    
  if (!isMobile) return (
    <PaymentErrorWrapper transparent={!filled}>
        <ErrorTitle>{t("send_gift.error.title")}</ErrorTitle>
        <ErrorText mb={secondTextLine ? 4 : undefined}>
            {t(text || '')}
        </ErrorText>
        { secondTextLine && <ErrorText>{t(secondTextLine)}</ErrorText>}
        {hasSummaryInfo &&
            <ErrorInfo>
                <SummaryInfoList offsetBottom={0} offsetTop={0}/>
            </ErrorInfo>
        }
        {
            isZeland
                ? <Button.YellowRectMedium onClick={onTryAgainClick}>
                    <ButtonTypography>{t("send_gift.error.try")}</ButtonTypography>
                </Button.YellowRectMedium>
                : <PaymentButtonSolid leveling onClick={onTryAgainClick}>{t("send_gift.error.try")}</PaymentButtonSolid>
        }
    </PaymentErrorWrapper>
  )

  return <PaymentErrorOuterWrapper>
        <ErrorTitle mobile={isMobile}>{t("send_gift.error.title")}</ErrorTitle>
        <ErrorText mobile={isMobile}>{text}</ErrorText>
        <PaymentErrorWrapper transparent={!filled} mobile={isMobile}>
            {hasSummaryInfo &&
                <SummaryInfoList offsetBottom={0} offsetTop={32}/>
            }
            <PaymentButtonSolid onClick={onTryAgainClick}>{t("send_gift.error.try")}</PaymentButtonSolid>
        </PaymentErrorWrapper>
    </PaymentErrorOuterWrapper>
}